export enum DefaultGroupViewKeys {
  normalGroupQuestionReport_downloadAsPDFTooltip = "normalGroupQuestionReport_downloadAsPDFTooltip",
}
